export default (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    role="img"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Back</title>
    <path
      d="M14.348 4.852 3.2 16l11.148 11.148M3.2 16h25.6"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
